import React from "react";
import './buttonMenu.css';
import {Link} from "react-router-dom";
import {FormattedMessage} from "react-intl";
import {isMobileDevice} from "../../../utils/utils";
import {useSelector} from "react-redux";
import app from "../index";
import users from "../../users";

const ButtonMenu = ({classIcon, text, route, className, style, verified, onClick, alert, forceBig, customIcon}) => {
    const darkMode = useSelector(users.selectors.isDarkMode);

    if (isMobileDevice() && !forceBig) {
        return (
            <Link
                className={(darkMode ? "text-light" : "text-dark") + " button-menu " + className + ` ${!verified ? "disabled" : ""}`}
                to={route} style={{cursor: "pointer", userSelect: "none", textDecoration: "none", ...style}}>
                <div className="card-body mt-0 pt-0" onClick={onClick} style={{fontSize: "large", fontWeight: "500"}}>
                    <div className="d-flex flex-column justify-content-center align-items-center"
                         style={{height: '60px'}}>
                        {customIcon && customIcon}
                        {classIcon && <div>
                            <i className={classIcon + " fa-lg"}/>{!verified && <i className="fa-solid fa-lock ms-1"/>}
                        </div>}
                        <div style={{fontSize: 'small', marginTop: '-4px', whiteSpace: "nowrap"}} className="position-relative">
                            {/*{text}*/}
                            {alert &&
                                <span
                                    className="position-absolute translate-middle p-1 bg-danger border border-light rounded-circle"
                                style={{top: "3px", right: '-15px'}}>
                    <span className="visually-hidden">New alerts</span>
                </span>}</div>
                    </div>
                </div>
            </Link>
        )
    }

    return (
        <Link
            className={(darkMode ? "text-light" : "text-dark") + " card button-menu " + className + ` ${!verified ? "disabled" : ""}`}
            to={route} style={{cursor: "pointer", userSelect: "none", textDecoration: "none", ...style}}>
            <div className="card-body" onClick={onClick} style={{fontSize: "large", fontWeight: "500"}}>
                <div className="d-flex flex-row justify-content-between align-items-center">
                    <div>
                        {classIcon && <i className={classIcon + " me-3"}/>}
                        {customIcon && customIcon}
                        {text}
                    </div>
                    <div>
                        {!verified &&
                            <span>
                        &nbsp; <i className="fa-solid fa-lock"/>
                    </span>}
                    </div>
                </div>
            </div>
            {alert &&
                <span
                    className="position-absolute top-0 start-100 translate-middle p-2 bg-danger border border-light rounded-circle">
                    <span className="visually-hidden">New alerts</span>
                </span>}
        </Link>
    );
};

export default ButtonMenu;
